/* eslint no-param-reassign: 0, import/no-cycle: 0 */
import {
  LocalStorageConsts,
  RouteGenerator,
} from 'client/util/Constants';
import { UiEvents, anonymousIdentify } from '@jumpcloud/ui-events-vue';
import { validate as uuidValidate, v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import EventManager from 'client/GrowthEngineering/EventManager';
import ExperimentsManager from 'client/GrowthEngineering/ExperimentsManager';
import SignupApi from 'client/signup/api/SignupApi';
import SignupConstants from 'client/util/Constants/SignupConstants';
import StoreConfigConstants from 'client/util/Constants/StoreConfigConstants';
import Util from 'client/util/Util';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import Vue from 'vue';
import router from 'client/signup/routes/Router';

const {
  segmentMap,
  partnerMarketing,
  visitorId,
  segmentUuid,
} = LocalStorageConsts;
const { adminPortalLandingPage, mtpLandingPage } = RouteGenerator;

const { shuffleArray } = Util;

const {
  clientType,
  clientTypeCookie,
  dataCenterRegions,
  freeEmails,
  gtmEvents,
  SignupOptions,
} = SignupConstants;

const { admin } = clientType;

const {
  recaptchaState,
  utmQueryFieldConsts,
  utmMarketingFields,
} = StoreConfigConstants;

const utmQueryFields = [
  ...Object.values(utmQueryFieldConsts),
];

export function getUtmFields() {
  const utmData = {};

  utmQueryFields.forEach((fieldName) => {
    const record = JSON.parse(localStorage.getItem(fieldName));
    const marketingFieldName = utmMarketingFields[fieldName];
    if (record) {
      utmData[marketingFieldName] = record;
    }
  });

  return utmData;
}

function makeEventPayload(user) {
  return {
    companyName: user.companyName,
    companySize: user.companySize,
    country: user.country,
    dataCenter: user.dataCenter,
    state: user.state,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    partnerType: user.partnerType,
    phone: user.phone,
    hasPhonePreference: user.hasPhonePreference,
  };
}

export default {
  state: {
    cookiesAccepted: false,
    growthData: {
      experimentStates: {},
      onboardingState: {},
    },
    hasEmailQueryParam: false,
    hasLoaded: false,
    isMobile: false,
    isMobileScreen: false,
    marketingData: {
      Free_Account__c: 'True',
      GCLID__c: '',
      Initial_Campaign_Source__c: '',
      LeadSource: 'Free Account',
      Lead_Type__c: '',
      Referral_Source__c: '',
      gclid_field: '',
      license: 'on',
      signup: true,
      FreeAccount_UTM_Campaign__c: '',
      FreeAccount_UTM_Content__c: '',
      FreeAccount_UTM_Medium__c: '',
      FreeAccount_UTM_Source__c: '',
      FreeAccount_UTM_Term__c: '',
      first_touch__c: '',
      first_touch_date_time__c: '',
      segmentUuid: '',
    },
    query: {
      cs: 'Free.Account.Website',
      email: '',
      exp: '',
      rs: 'Website',
      variation: '',
      visitorId: '',
    },
    recaptchaLoaded: recaptchaState.NOT_LOADED,
    recaptchaExpired: true,
    registerError: '',
    step: 1,
    totalSteps: 4,
    useCaseDisplayText: '',
    user: {
      companyName: '',
      country: '',
      state: '',
      companySize: '',
      dataCenter: 'us',
      directory: [],
      doubleOptIn: true,
      email: '',
      firstName: '',
      hasDirectory: '',
      lastName: '',
      isValid: false,
      isPartner: '',
      partnerType: '',
      phone: '',
      hasPhonePreference: false,
      recaptchaToken: '',
      useCase: '',
      termsOfService: false,
      targetEnv: 'prd',
    },
    visitorId: '',
    isEmailValid: false,
  },
  mutations: {
    ADD_EXPERIMENT_GROWTH_DATA(state, { experimentId, experiment }) {
      Vue.set(state.growthData.experimentStates, experimentId, experiment);
    },
    ADD_TO_GROWTH_OBJECT(state, newData) {
      const newGrowthObject = { ...cloneDeep(state.growthData), ...newData };
      Vue.set(state, 'growthData', newGrowthObject);
    },
    UPDATE_COOKIESACCEPTED(state, value) {
      localStorage.setItem('jcCookiesAccepted', value);
      Vue.set(state, 'cookiesAccepted', value);
    },
    UPDATE_EXPERIMENT_STATE(state, { experimentId, experimentState }) {
      const currentState = get(state.growthData.experimentStates, experimentId, {});
      const newState = { ...currentState, ...experimentState };
      Vue.set(state.growthData.experimentStates, experimentId, newState);
    },
    UPDATE_GCLID(state, value) {
      Vue.set(state.marketingData, 'GCLID__c', value);
      Vue.set(state.marketingData, 'gclid_field', value);
    },
    UPDATE_HAS_EMAIL_QUERY_PARAM(state, value) {
      state.hasEmailQueryParam = value;
    },
    UPDATE_HASLOADED(state, value) {
      state.hasLoaded = value;
    },
    UPDATE_IS_MOBILE_SCREEN(state, value) {
      state.isMobileScreen = value;
    },
    UPDATE_ISVALID(state, value) {
      state.user.isValid = value;
    },
    UPDATE_PARSED_UTM_QUERY_VALUE(state, fieldData) {
      const fieldName = fieldData.name;
      const fieldValue = fieldData.value;
      const marketingFieldName = utmMarketingFields[fieldName];
      if (marketingFieldName) {
        state.marketingData[marketingFieldName] = fieldValue;
      }
    },
    UPDATE_RECAPTCHA(state, value) {
      state.recaptchaLoaded = value;
    },
    UPDATE_RECAPTCHA_EXPIRED(state, value) {
      state.recaptchaExpired = value;
    },
    UPDATE_RECAPTCHA_TOKEN(state, value) {
      state.user.recaptchaToken = value;
    },
    UPDATE_REFERRAL_URL(state, value) {
      Vue.set(state.growthData.onboardingState, 'signupReferralUrl', value);
    },
    UPDATE_REGISTER_ERROR(state, error) {
      state.registerError = error;
    },
    UPDATE_SEGMENT_MAP(state, value) {
      state.growthData.onboardingState.segmentMap = value;
      try {
        sessionStorage.setItem(segmentMap, JSON.stringify(value));
      } catch (e) {
        // catch and move on
      }
    },
    UPDATE_STEP(state, step) {
      state.step = step;
    },
    UPDATE_QUERY(state, query) {
      const updatedQuery = { ...state.query, ...query };
      state.query = updatedQuery;
      state.marketingData.Initial_Campaign_Source__c = updatedQuery.cs;
      state.marketingData.Referral_Source__c = updatedQuery.rs;
    },
    UPDATE_USE_CASE(state, value) {
      // useCase is the mapped useCase value that gets sent to the backend
      // useCaseDisplayText is what was displayed on the button selected
      // some display elements need to know
      state.user.useCase = value.useCase;
      state.useCaseDisplayText = value.useCaseDisplayText;
    },
    UPDATE_EMAIL(state, email) {
      state.user.email = email;
    },
    UPDATE_EMAIL_VALID(state, value) {
      state.isEmailValid = value;
    },
    UPDATE_VISITOR_ID(state, id) {
      state.visitorId = id;
      localStorage.setItem(visitorId, JSON.stringify(id));
    },
    UPDATE_SEGMENT_UUID(state, id) {
      state.marketingData.segmentUuid = id;
      localStorage.setItem(segmentUuid, id);
    },
    UPDATE_IS_MOBILE(state, value) {
      state.isMobile = value;
    },
    UPDATE_PARTNER_RESPONSES(state, payload) {
      state.user.companySize = payload.companySize;
      state.user.country = payload.country;
      state.user.partnerType = payload.partnerType;

      if (payload.partnerType) {
        state.user.isPartner = 'Yes';
      } else {
        state.user.isPartner = 'No';
      }
    },
    UPDATE_TARGET_ENV(state, env) {
      state.user.targetEnv = env;
    },
    SET_TARGET_ENV_COOKIE(state, env) {
      Cookies.set('_jc_target_env', env);
    },
  },
  actions: {
    addExperimentToGrowthData({ commit }, experiment) {
      if (!isEmpty(experiment) && !isEmpty(experiment.variation)) {
        const experimentToAdd = {
          experimentName: experiment.experimentName,
          variationState: {
            variationId: experiment.variation.id,
            variationName: experiment.variation.name,
          },
        };
        const experimentId = experiment.id;
        commit('ADD_EXPERIMENT_GROWTH_DATA', { experimentId, experiment: experimentToAdd });
      }
    },
    backStep({ state }, step) {
      const { user } = state;
      const userInfo = makeEventPayload(user);
      EventHelper.triggerSignupStepBack({ step, userInfo });
    },
    checkCookiesAccepted({ commit }) {
      const hasAcceptedCookies = localStorage.getItem('jcCookiesAccepted') === 'true';
      commit('UPDATE_COOKIESACCEPTED', hasAcceptedCookies);
    },
    clearUtmValues({ commit }) {
      utmQueryFields.forEach((fieldName) => {
        localStorage.removeItem(fieldName);
        commit('UPDATE_PARSED_UTM_QUERY_VALUE', { name: fieldName, value: '' });
      });
    },
    completeStep({ state }, step) {
      const { user } = state;
      const userInfo = makeEventPayload(user);
      EventHelper.triggerSignupStepCompleted({ step, userInfo });
    },
    getGclidRecord({ commit, state }) {
      const gclidParam = state.query.gclid;
      const gclsrcParam = state.query.gclsrc;

      const isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;
      let gclidRecord;

      // Check if gclid is in URL param; if so, save and store in local storage
      if (gclidParam && isGclsrcValid) {
        const expiryDate = new Date().getTime() + (90 * 24 * 60 * 60 * 1000); // 90 day expiry
        gclidRecord = {
          value: gclidParam,
          expiryDate,
        };
        localStorage.setItem('gclid', JSON.stringify(gclidRecord));
      }

      // Check if gclid is stored in local storage; if so, use that
      const gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
      if (gclid && new Date().getTime() < gclid.expiryDate) {
        commit('UPDATE_GCLID', gclid.value);
      }
    },
    parseUtmQueryFields({ commit, state }) {
      let utmFieldsReceived = false;
      // Sometimes other JC pages give us UTMs or First Touch values which are not lowercase
      // We want to accept all of them if they match the key
      // In order to do that we translate the keys to be lowercase so we can then parse the values
      const lowercaseQueryObject = {};
      Object.keys(state.query).forEach((queryKey) => {
        lowercaseQueryObject[queryKey.toLowerCase()] = state.query[queryKey];
      });

      // Parse all utmQueryFields when signup loads
      // This will update with new values from the query params and load old values into the store
      utmQueryFields.forEach((fieldName) => {
        try {
          let fieldRecord;
          const fieldValue = lowercaseQueryObject[fieldName];

          if (fieldValue) {
            const expiryDate = new Date().getTime() + (90 * 24 * 60 * 60 * 1000); // 90 day expiry
            fieldRecord = {
              value: fieldValue,
              expiryDate,
            };

            localStorage.setItem(fieldName, JSON.stringify(fieldRecord));

            // If we're here, we recieved a utm value in the query params
            utmFieldsReceived = true;
          }

          const record = fieldRecord || JSON.parse(localStorage.getItem(fieldName));
          if (record && new Date().getTime() < record.expiryDate) {
            commit('UPDATE_PARSED_UTM_QUERY_VALUE', { name: fieldName, value: record.value });
          }
        } catch (e) {
          // just catch and move on if there's an error
        }
      });

      if (utmFieldsReceived) {
        EventHelper.triggerSignupUtmData(getUtmFields());
      }
    },
    setRecaptchaLoaded({ commit }, value) {
      if (recaptchaState[value]) {
        commit('UPDATE_RECAPTCHA', value);
      }
    },
    setRecaptchaToken({ commit }, value) {
      commit('UPDATE_RECAPTCHA_TOKEN', value);
    },
    setRecaptchaExpired({ commit }, value) {
      commit('UPDATE_RECAPTCHA_EXPIRED', value);
    },
    setStep({ commit }, step) {
      commit('UPDATE_STEP', step ? parseInt(step, 10) : 1);
    },
    setTargetEnv({ commit }, dataCenter) {
      const env = dataCenterRegions[dataCenter] && dataCenterRegions[dataCenter].environment
        ? dataCenterRegions[dataCenter].environment
        : 'prd';
      commit('UPDATE_TARGET_ENV', env);
      commit('SET_TARGET_ENV_COOKIE', env);
    },
    initializeTargetEnv({ commit }) {
      commit('SET_TARGET_ENV_COOKIE', 'prd');
    },
    setValidation({ commit }, value) {
      commit('UPDATE_ISVALID', value);
    },
    sendInputEnteredEvent({ state }, { name, label }) {
      const { isEmailValid, user } = state;
      const formPayload = {
        firstName: user.firstName,
        lastName: user.lastName,
        isPartner: user.isPartner,
        partnerType: user.partnerType,
        companyName: user.companyName,
        companySize: user.companySize,
        country: user.country,
        state: user.state,
        dataCenter: user.dataCenter,
        doubleOptIn: user.doubleOptIn,
        phone: user.phone,
        hasPhonePreference: user.hasPhonePreference,
        email: {
          email: user.email,
          isValid: isEmailValid,
        },
        termsOfService: user.termsOfService,
      };
      const eventPayload = {
        description: `${name} input`,
        page: 'Signup Page',
        section: 'Signup Form',
        text: label,
        value: formPayload,
      };

      UiEvents.triggerInputEntered(eventPayload);
    },
    submitRegistration({
      commit, dispatch, getters, state,
    }, nextLink) {
      const {
        marketingData = {},
        registerError,
        user,
      } = state;

      const {
        getGrowthData,
      } = getters;

      // Send Segment event to track registration submissions
      const eventPayload = makeEventPayload(user);

      if (registerError) commit('UPDATE_REGISTER_ERROR', '');
      const utmData = getUtmFields();
      EventManager.triggerSignupSubmitted({ ...eventPayload, ...utmData });
      ExperimentsManager.trackExperimentEvent('signup_submission');
      anonymousIdentify({
        traits: {
          ...eventPayload,
          ...marketingData,
        },
      });

      const selectedDirectories = [];
      if (user.directory.length) {
        user.directory.forEach((directory) => {
          selectedDirectories.push(directory.value);
        });
      }

      const payload = {
        ...marketingData,
        company: user.companyName,
        company_size: user.companySize,
        email: user.email,
        first_name: user.firstName,
        growthData: getGrowthData,
        last_name: user.lastName,
        sendRegistrationCode: true,
        termsOfService: user.termsOfService,
        Country: user.country,
        dataCenter: user.dataCenter,
        Directory__c: selectedDirectories,
        Double_Opt_In__c: user.doubleOptIn,
        Phone: user.phone,
        PhonePreference: user.hasPhonePreference,
        Use_Case__c: user.useCase,
        'g-recaptcha-response': user.recaptchaToken,
      };

      if (user.isPartner === 'Yes') {
        payload.Lead_Type__c = user.partnerType;
      } else {
        payload.Lead_Type__c = '';
      }

      if (user.state) {
        payload.state = user.state;
      }

      return SignupApi.register(payload)
        .then(async () => {
          try {
            // Trigger Segment event for account creation
            await EventManager.triggerAccountCreated(eventPayload);
            // Trigger GTM event for account creation
            if (window.dataLayer) {
              window.dataLayer.push(gtmEvents.freeAccountTrackingEvent);
            }
          } catch (e) {
            // Do nothing, just catch for safety and move on
          }

          dispatch('clearUtmValues');
          dispatch('setValidation', true);
          dispatch('updateCookiesAccepted', true);
          router.push(nextLink).catch((err) => {
            // Ignore NavigationDuplicated for CircleCI
            if (
              err.name !== 'NavigationDuplicated'
              && !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But throw any other errors
              throw err;
            }
          });
        })
        .catch((error) => {
          const defaultErrorMessage = 'There was an error registering your account. Please try again.';
          const errorMessage = get(error, 'response.data.message', defaultErrorMessage);
          commit('UPDATE_REGISTER_ERROR', errorMessage);
          return errorMessage;
        });
    },
    confirmPartnerRegistration({
      dispatch, state,
    }, { code, emailAddress }) {
      const {
        user,
      } = state;

      // Need to define all these things or pull from state?
      const payload = {
        companySize: user.companySize,
        country: user.country,
        email: emailAddress,
        partnerType: user.partnerType,
        registrationCode: code,
      };

      // save the form responses incase the verifcation fails
      try {
        sessionStorage.setItem(partnerMarketing, JSON.stringify(payload));
      } catch (e) {
        // catch and move on
      }

      return SignupApi.confirmPartnerRegistration(payload)
        .then((res) => dispatch('triggerVerificationEventsAndRedirect', { emailAddress, confirmResponse: res }));
    },

    confirmRegistration({
      dispatch,
    }, { code, emailAddress }) {
      return SignupApi.confirmRegistrationCode(emailAddress, code)
        .then((res) => dispatch('triggerVerificationEventsAndRedirect', { emailAddress, confirmResponse: res }));
    },

    triggerVerificationEventsAndRedirect(_, { confirmResponse, emailAddress }) {
      // We're not resolving or rejecting as we should redirect
      // if there's an error the caller should catch it
      // Disable rule for not having async promise functions
      // eslint-disable-next-line
      return new Promise(async (resolve) => {
        try {
          // Trigger Segment event
          const { triggerAccountVerified } = EventManager;
          triggerAccountVerified({
            email: emailAddress,
          });

          // Trigger GTM event
          if (window.dataLayer) {
            window.dataLayer.push(gtmEvents.accountVerified);
            // Enhanced tracking helps Google Analytics track conversions
            // across domains/browers/devices
            // At this time (Dec-2022), it only works for gmail accounts
            // We still want to trigger the event for all email and GA will sort it out
            // If support for business email is added this implementation will automatically improve
            const googleEnhancedConversionDataEventCopy = {
              ...gtmEvents.googleEnhancedConversionDataEvent,
            };
            googleEnhancedConversionDataEventCopy.enhanced_conversion_data = {
              email: emailAddress,
            };
            window.dataLayer.push(googleEnhancedConversionDataEventCopy);

            const isFreeEmail = freeEmails.some((email) => emailAddress.indexOf(email) >= 0);
            if (isFreeEmail) {
              // Trigger Free domain VFA GTM event
              window.dataLayer.push(gtmEvents.accountVerifiedFreeEmail);
            } else {
              window.dataLayer.push(gtmEvents.accountVerifiedBusinessDomain);
            }
          }
        } catch (e) {
          // Do nothing, just catch for safety and move on
        }
        // Redirect admin after a short timeout
        setTimeout(() => {
          sessionStorage.removeItem(partnerMarketing);
          try {
            Cookies.set(clientTypeCookie, admin);
          } catch (e) {
            // Do nothing, just catch for safety and move on
          }
          const { lastUrl } = (confirmResponse && confirmResponse.data) || {};
          const redirectUrl = lastUrl && lastUrl === mtpLandingPage
            ? mtpLandingPage : adminPortalLandingPage;

          window.location.assign(redirectUrl);
          resolve();
        }, 1000);
      });
    },
    updateCookiesAccepted({ commit }, value) {
      commit('UPDATE_COOKIESACCEPTED', value);
    },
    updateHasLoaded({ commit }, value) {
      commit('UPDATE_HASLOADED', value);
    },
    updateHasEmailQueryParam({ commit }, value) {
      commit('UPDATE_HAS_EMAIL_QUERY_PARAM', value);
    },
    updateIsMobileScreen({ commit }, value) {
      commit('UPDATE_IS_MOBILE_SCREEN', value);
    },
    updateQueryStrings({ commit, dispatch }, query) {
      commit('UPDATE_QUERY', query);
      dispatch('getGclidRecord');
      dispatch('parseUtmQueryFields');
    },
    updateReferrer({ commit, state }, referralSource) {
      // update if not previously updated
      const currentSignupReferralUrl = get(state, 'growthData.onboardingState.signupReferralUrl', '');
      if (!currentSignupReferralUrl) {
        const signupReferralUrl = referralSource || get(window, 'document.referrer', '');
        const trimmedSignupReferralUrl = signupReferralUrl.split('?')[0];

        // Pass the signupReferralUrl in for all signups
        // Let admin portal logic determine what to do
        commit('UPDATE_REFERRAL_URL', trimmedSignupReferralUrl);
      }
    },
    updateUseCase({ commit }, value) {
      commit('UPDATE_USE_CASE', value);
    },
    updateEmail({ commit }, email) {
      commit('UPDATE_EMAIL', email);
    },
    updateEmailValid({ commit }, value) {
      commit('UPDATE_EMAIL_VALID', value);
    },
    updateVisitorId({ commit }, id) {
      commit('UPDATE_VISITOR_ID', id);
    },
    updateSegmentUuid({ commit }, id) {
      commit('UPDATE_SEGMENT_UUID', id);
    },
    updateIsMobile({ commit }, value) {
      commit('UPDATE_IS_MOBILE', value);
    },
    updatePartnerResponses({ commit }, email) {
      const payload = JSON.parse(sessionStorage.getItem(partnerMarketing));

      if (payload && payload.email === email) {
        commit('UPDATE_PARTNER_RESPONSES', payload);
      }
    },
    updateSegmentMap({ commit }, value) {
      commit('UPDATE_SEGMENT_MAP', value);
    },
    writeToGrowthObject({ commit }, newData) {
      commit('ADD_TO_GROWTH_OBJECT', newData);
    },
  },
  getters: {
    getGrowthData(state) {
      try {
        const currentSegmentMap = get(state, 'growthData.onboardingState.segmentMap', {});
        const signupSegmentMap = JSON.parse(sessionStorage.getItem(segmentMap));
        if (isEmpty(currentSegmentMap) && signupSegmentMap) {
          Vue.set(state.growthData.onboardingState, 'segmentMap', signupSegmentMap);
        }
      } catch (e) {
      // catch and move on
      }
      return state.growthData;
    },
    getPartnerOptions() {
      return shuffleArray(SignupOptions.partnerOptions);
    },
    getPartnerTypeOptions() {
      return shuffleArray(SignupOptions.partnerTypeOptions);
    },
    getSegmentUuid(state) {
      if (!state.marketingData.segmentUuid) {
        // Check if segmentUuid is stored in local storage
        let storedId = '';
        storedId = localStorage.getItem('segmentUuid') || '';

        if (storedId !== '') {
          return storedId;
        }

        // Otherwise, check for query string param
        const urlParams = new URLSearchParams(window.location.search);
        const marketingSegmentUuid = urlParams.get('jcsgmtuuid');

        // Return query string uuid if exists, otherwise return empty string
        return marketingSegmentUuid || storedId;
      }

      return state.marketingData.segmentUuid;
    },
    getTargetEnv(state) {
      return state.targetEnv;
    },
    getVisitorId(state) {
      if (!state.visitorId) {
        // Check if visitorId is stored in local storage
        let storedId = '';

        try {
          storedId = JSON.parse(localStorage.getItem(visitorId)).toString();
        } catch {
          // in case we get invalid JSON from legacy visitors, let storedId remain empty and move on
        }

        // validate uuid for legacy return visitors
        if (storedId && uuidValidate(storedId)) {
          return storedId;
        }

        // Otherwise, associate user IDs between Marketing site and Signup if pre-existing
        const urlParams = new URLSearchParams(window.location.search);
        let userId = urlParams.get('jcexpuuid');

        if (!userId) {
          userId = uuidv4();
        }

        return userId;
      }

      return state.visitorId;
    },
  },
};
